
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-48">
          <Link to="/" className="flex items-center">
            <img 
              src="/lovable-uploads/8ed95d40-fbd6-4827-b66c-78f7be0c337d.png" 
              alt="Contract Funding Group Logo" 
              className="h-40 w-auto" 
            />
          </Link>
          
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-slate-900 transition-colors">
              Home 
            </Link>
            <Link to="/why-invest-in-land-contracts" className="text-gray-700 hover:text-slate-900 transition-colors">
              Why Invest
            </Link>
            <Link to="/note-investing-education" className="text-gray-700 hover:text-slate-900 transition-colors">
              Learn Note Investing
            </Link>
            <Link to="/contracts-vs-rental" className="text-gray-700 hover:text-slate-900 transition-colors font-semibold">
              Contracts VS Rental
            </Link>
            <Link to="/about-land-contracts" className="text-gray-700 hover:text-slate-900 transition-colors">
              About Land Contracts
            </Link>
            <Link to="/due-diligence" className="text-gray-700 hover:text-slate-900 transition-colors">
              Due Diligence
            </Link>
            <Link to="/investor-sales-pitch" className="text-gray-700 hover:text-slate-900 transition-colors font-semibold">
              Investor Sales Pitch
            </Link>
            <Link to="/investor-portal">
              <Button variant="outline" className="border-yellow-800 text-yellow-800 hover:bg-yellow-800 hover:text-white">
                Investor Portal
              </Button>
            </Link>
            <Link to="/admin-portal">
              <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white">
                Admin Portal
              </Button>
            </Link>
          </div>
          
          <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
        
        
        {isOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-slate-900">
                Home
              </Link>
              <Link to="/why-invest-in-land-contracts" className="text-gray-700 hover:text-slate-900">
                Why Invest
              </Link>
              <Link to="/note-investing-education" className="text-gray-700 hover:text-slate-900">
                Learn Note Investing
              </Link>
              <Link to="/contracts-vs-rental" className="text-gray-700 hover:text-slate-900 font-semibold">
                Contracts VS Rental
              </Link>
              <Link to="/about-land-contracts" className="text-gray-700 hover:text-slate-900">
                About Land Contracts
              </Link>
              <Link to="/due-diligence" className="text-gray-700 hover:text-slate-900">
                Due Diligence
              </Link>
              <Link to="/investor-sales-pitch" className="text-gray-700 hover:text-slate-900 font-semibold">
                Investor Sales Pitch
              </Link>
              <Link to="/investor-portal" className="text-yellow-800 font-medium">
                Investor Portal
              </Link>
              <Link to="/admin-portal" className="text-blue-600 font-medium">
                Admin Portal
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
